import { render, staticRenderFns } from "./tripleStubMatch.vue?vue&type=template&id=54668f39&scoped=true&"
import script from "./tripleStubMatch.vue?vue&type=script&lang=js&"
export * from "./tripleStubMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54668f39",
  null
  
)

export default component.exports